<template>
  <v-card tile class="selection-background">
    <v-toolbar class="selection-background" dark>
      <v-toolbar-title>Выбор элемента</v-toolbar-title>
    </v-toolbar>

    <!-- list of types of speech blocks -->

    <v-card
      v-for="SBlockType in $store.getters.SBlockTypes"
      :key="'sel-sblock-type-id-' + SBlockType.id"
      @click="selSBlockType = SBlockType"
      class="active-sblock-type"
      tile
    >
      <s-block-type-info
        :s-block-type="SBlockType">
      </s-block-type-info>
    </v-card>

    <!-- actions for selection -->

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="#ec1946" class="ma-2" @click="setSelectedSBlockType">
        <span class="white--text">Добавить</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import SBlockTypeInfo from './SBlockTypeInfo'

/***
 * presentation of the selection of type of speech block
 */

export default {
  name: 'SBlockTypeSelection',
  components: { SBlockTypeInfo },
  data () {
    return {
      /***
       * selected type of speech block
       * */
      selSBlockType: undefined
    }
  },
  methods: {
    /***
     * calls a select event
     *
     * @return {Object} selected speech block
     * */
    setSelectedSBlockType () {
      this.$emit('selected', this.selSBlockType)
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/colors';
  .selection-background {
    background-color: $itmo-blue!important;
  }
  .active-sblock-type:focus {
    padding-left: 30px!important;
    background-color: $itmo-red!important;
  }
</style>
